













































































































































































































































































































import { Component, PropSync, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  PartnerOnboardingStatusEnum, PartnersApi, DocumentRequest, Document,
} from '@compassdigital/foodworks.ts.sdk';
import FileUtil from '@/util/FileUtil';
import Format from '@/util/Format';
import UserModule from '@/store/modules/user';
import PartnerModule from '@/store/modules/partner';
import AppModule from '@/store/modules/app';
import SecondaryButton from '@/components/Buttons/SecondaryButton/index.vue';
import DeleteDocument from '@/components/Form/DeleteDocument/index.vue';
import ApproveForm from '@/components/Modal/ApproveForm/index.vue';
import ReviewComments from '@/components/Modal/ReviewComments/index.vue';
import RejectForm from '@/components/Modal/RejectForm/index.vue';
import { IDocumentInfo } from '@/interface/documentInfo';
import ToastModule from '@/store/modules/toast';
import Service from '@/util/ServiceUtil';
import Documents from '../Documents/index.vue';
import PermissionMixin from '../../../../mixins/PermissionMixin';
@Component({
  components: {
    SecondaryButton,
    DeleteDocument,
    ApproveForm,
    RejectForm,
    ReviewComments,
  },
})
export default class DocumentsList extends mixins(FileUtil, PermissionMixin) {
  @PropSync('documents', {}) documentsSync!: Array<Document>;

  private showDeleteDocument: boolean = false;

  @Prop({}) documentType!: string;

  @Prop({}) partnerID!: string;

  @Prop({}) expiryValue!: string;

  private statusPartner: boolean = false;

  private isOpen: boolean = false;

  private rowHoverID: number = -1;

  private trashDocument: any = null;

  private userStatus: string = '';

  private documentDate: any = Format.getCurrentDate();

  private documentID: string = '';

  private openApprove: boolean = false;

  private rejectDialog: boolean = false;

  private urlFile: string = '';

  private urlFileName: string = '';

  private documentId: string = '';

  private reviewDialog: boolean = false;

  private formUploadValue: string = '';

  private documentComment: Document = {
    comment: '',
  }

  private documentStatus: any = {
    status: '',
  }

  private reviewDocument: Document = {};

  private loading: boolean = false;

  private documentMinDate: any = Format.getCurrentDate();

  public onUpload() {
    this.$emit('upload');
  }

  public onDownload(url: string) {
    const a = document.createElement('a');
    a.style.display = 'none';
    document.body.appendChild(a);

    // Set the HREF to a Blob representation of the data to be downloaded
    a.href = url;
    a.setAttribute('download', '');
    a.setAttribute('target', '_blank');

    // Use download attribute to set set desired file name
    // Trigger the download by simulating click
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(a.href);
    document.body.removeChild(a);
  }

  public onDeleteDocument(document: Document) {
    this.trashDocument = document;
    this.showDeleteDocument = true;
  }

  public onOptionDelete() {
    this.$emit('delete', this.trashDocument);
    this.showDeleteDocument = false;
  }

  public onOptionCancel() {
    this.trashDocument = null;
    this.showDeleteDocument = false;
  }

  public toggle() {
    this.isOpen = !this.isOpen;
  }

  public onMouseLeave() {
    this.isOpen = false;
    this.rowHoverID = -1;
  }

  public getDocumentName(url: string) {
    this.urlFile = url;
    let name = url.split('/').reverse()[0];
    if (name.lastIndexOf('-') > 0) {
      const ext = name.substr(name.lastIndexOf('.') + 1);
      name = `${name.split('-')[0]}.${ext}`;
    }
    this.urlFileName = name;
    return name;
  }

  public getDocumentFormat(date: string) {
    return Format.getFomattedDate(date);
  }


  public getDocumentDate(uploadDate: any) {
    return Format.getFomattedDate(uploadDate);
  }

  public get getPartnerStatus() {
    this.getFetchStatus();
    const status = PartnerModule.restaurantStatus;
    if (status) {
      this.userStatus = status;
    }
    if (this.onBoardingPartnerID && status === 'completed') {
      this.statusPartner = true;
    }
    return status;
  }

  public async getFetchStatus() {
    const fetchStatus = await PartnerModule.fetchRestaurantsProfile(this.partnerID);
  }

  get onBoardingPartnerID() {
    if (UserModule.currentUser && UserModule.currentRole === 'partner_owner') {
      return UserModule.currentUser.id;
    }
    return '';
  }

  public onOpenApproveForm(formStatus: string, docID: string) {
    this.openApprove = true;
    this.formUploadValue = formStatus;
    this.documentId = docID;
  }

  public openRejectDialog(formStatus: string, docID: string) {
    this.rejectDialog = true;
    this.formUploadValue = formStatus;
    this.documentId = docID;
  }

  public closeRejectDialog() {
    this.rejectDialog = false;
    this.documentComment.comment = '';
  }

  public onCancel() {
    this.openApprove = false;
  }

  public async onApproveForm() {
    this.documentStatus = this.formUploadValue;
    const documentData: Document = {};
    if (this.formUploadValue) {
      if (this.formUploadValue === 'rejected') {
        documentData.comment = this.documentComment.comment;
        documentData.status = this.documentStatus;
        documentData.docApproverName = this.scoutUserName;
        documentData.docApproverId = this.scoutUserID;
      } else {
        documentData.status = this.documentStatus;
        documentData.docApproverName = this.scoutUserName;
        documentData.docApproverId = this.scoutUserID;
      }
      try {
        this.loading = true;
        const api = new PartnersApi(AppModule.apiConfig);
        const data = await api.patchPartnerDocument(
          this.partnerID, this.documentId, documentData,
        );
        this.openApprove = false;
        this.rejectDialog = false;
        if (data.status === 200) {
          this.$emit('documentUpdated', this.partnerID);
          this.documentComment.comment = '';
        }
      } catch (error) {
        this.openApprove = false;
        this.rejectDialog = false;
        const { message } = error.response.data.error;
        if (message) {
          ToastModule.setToast({
            message,
            timeout: 5000,
          });
        }
      }
      this.loading = false;
    }
  }

  public get scoutUserID() {
    return UserModule.userId;
  }

  public get scoutUserName() {
    return UserModule.fullname;
  }

  public async onSelectDate(date: any, id: string) {
    const documentData: Document = {};
    documentData.expiryDate = date;
    try {
      const api = new PartnersApi(AppModule.apiConfig);
      const data = await api.patchPartnerDocument(
        this.partnerID, id, documentData,
      );
      if (data.status === 200) {
        this.documentDate = null;
        this.$emit('documentUpdated', this.partnerID);
      }
    } catch (error) {
      this.documentDate = null;
      const { message } = error.response.data.error;
      if (message) {
        ToastModule.setToast({
          message,
          timeout: 5000,
        });
      }
    }
  }

  public openDialogComments(doc: Document) {
    this.reviewDialog = true;
    this.reviewDocument = doc;
  }

  public onCloseReviewComments() {
    this.reviewDialog = false;
  }

  public get approverStatus() {
    const userStatus = Service.approverUser();
    if (userStatus || this.userStatus === 'completed') {
      return true;
    }
    return false;
  }

  public get documentApprover() {
    const userStatus = Service.approverUser();
    if (userStatus) {
      return true;
    }
    return false;
  }

  public get documentNonApprover() {
    const userStatus = Service.nonApproverUser();
    if (userStatus) {
      return true;
    }
    return false;
  }

  public getDocName(url: string) {
    let name = url.split('/').reverse()[0];
    if (name.lastIndexOf('-') > 0) {
      const ext = name.substr(name.lastIndexOf('.') + 1);
      name = `${name.split('-')[0]}.${ext}`;
    }
    return name;
  }

  public getDocumentExpireStatus(expDate: any) {
    return Service.getDocumentExpire(expDate);
  }

  get adminUser() {
    if (UserModule.currentRole === 'fw_admin'
    || UserModule.currentRole === 'fw_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }

  public get documentExpiryForm() {
    return Service.getdocumentExpiryForm(this.documentsSync);
  }

  public get documentRejected() {
    return Service.getdocumentRejected(this.documentsSync);
  }
}
